import React from 'react';

const AutomationErrorLogDetailsFacets = ({ automationErrorLogsDetails }) => {
  const { selectedWorkflowTitle = 'N/A', selectedTriggerName = 'N/A', selectedActionNames = [] } = automationErrorLogsDetails || {};
  return (
    <>
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-2 col-12 text-muted p-medium me-1">Rule Title</div>
        <div className="col-md-9 col-12 d-flex align-items-center">
          <span className="me-2">{selectedWorkflowTitle}</span>
        </div>
      </div>

      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-2 col-12 text-muted p-medium me-1">Trigger</div>
        <div className="col-md-9 col-12 d-flex align-items-center">
          <span className="me-2">{selectedTriggerName}</span>
        </div>
      </div>

      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-2 col-12 text-muted p-medium me-1">Action</div>
        <div className="col-md-9 col-12 d-flex align-items-center">
          <span>{selectedActionNames?.join(', ') || 'N/A'}</span>
        </div>
      </div>
    </>
  );
};

export default AutomationErrorLogDetailsFacets;
